<!-- <ngx-loading-bar [color]="'#7366ff'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar> -->
<!-- <app-loader></app-loader> -->
<!--<app-tap-to-top></app-tap-to-top>-->
<!--<router-outlet></router-outlet>-->
<!--<router-outlet name='register'></router-outlet>-->

<!--<app-splash-screen *ngIf="loaderService.isLoading"></app-splash-screen>-->

<!--<div *ngIf="!loaderService.isLoading">-->
<!--    <app-tap-to-top></app-tap-to-top>-->
<!--    <router-outlet></router-outlet>-->
<!--    <router-outlet name="register"></router-outlet>-->
<!--</div>-->

<app-splash-screen *ngIf="loaderService.isLoading"></app-splash-screen>

<div *ngIf="!loaderService.isLoading">
    <!-- Afficher la page d’avertissement si mobile ou tablette -->
<!--    <app-mobile-warning *ngIf="isMobileOrTablet"></app-mobile-warning>-->

    <!-- Sinon, afficher l'application normale -->
<!--    <div *ngIf="!isMobileOrTablet">-->
    <div>
        <app-tap-to-top></app-tap-to-top>
        <router-outlet></router-outlet>
        <router-outlet name="register"></router-outlet>
    </div>
</div>

<ng-template #content let-modal>
    <div class="custom-modal-container">

        <app-device-choice-modal></app-device-choice-modal>
        <button class="close-button" (click)="modal.dismiss('Cross click')">
            <i class="fa fa-times"></i>
        </button>
    </div>
</ng-template>


